import * as klaro from 'klaro/dist/klaro-no-translations';
import config from './klaro/klaroConfig';

if (window.config.environment !== 'local' && window.config.environment !== 'testing') {
    klaro.render(config);

    const klaroElement = document.querySelector('.klaro');

    if (klaroElement) {
        klaroElement.classList.add('cookie-notice');
    }
}
